// ... previous imports
import React from "react";
import Head from "../../components/Head";
import "./GHLSMSIntegration.css";

function GHLSMSIntegration() {
  return (
    <>
      <Head title="TextLink + GoHighLevel" />

      <div className="ghl-sms-integration-wrapper">
        {/* Back Button */}
        <div className="ghl-back-button">
          <a href="/">
            <ion-icon name="arrow-back-outline" className="ghl-back-icon"></ion-icon>
            Back
          </a>
        </div>

        {/* HERO / TITLE SECTION */}
        <div className="ghl-title-div">
          <h1>
            Supercharge Your GoHighLevel CRM <br />
            with Native SMS
          </h1>
          <p className="ghl-hero-subtitle">
            Get your SMS marketing up and running effortlessly in minutes with{" "}
            <strong>TextLinks + HighLevel</strong>. Experience seamless integration
            and cost-effective messaging like never before.
          </p>
          <button
            className="ghl-btn-primary ghl-btn-large"
            onClick={() => (window.location.href = '/signup')}
          >
            Get Started
          </button>
        </div>

        {/* 🔥 UNIQUE ADVANTAGE SECTION */}
        <div className="ghl-content-row highlight">
          <div className="ghl-text-column">
            <h2 className="ghl-section-title">
              One SIM. Multiple Locations.
            </h2>
            <p className="ghl-text-paragraph">
              With <strong>TextLink</strong>, you can connect <strong>multiple GoHighLevel sub-accounts</strong> (locations)
              to a single SIM card. No need to purchase and manage separate SIMs.
              Competitors like <strong>mycrmsim.com</strong> force you to get a new card for every account.
              That’s more hardware, more costs, more hassle.
            </p>
            <p className="ghl-text-paragraph">
              With TextLink, you simplify everything and scale effortlessly — all while paying less.
            </p>
          </div>
          <div className="ghl-video-column">
            <img
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQHU9oKRjehCqx_G-eSBKYsWEkw2hZpST2bbA&s"
              alt="Multi-location SIM support"
              style={{ maxWidth: "100%", borderRadius: "1rem", boxShadow: "0 4px 20px rgba(0,0,0,0.1)" }}
            />
          </div>
        </div>

        {/* FIRST ROW: Video (left) + Text/Stats (right) */}
        <div className="ghl-content-row">
          <div className="ghl-video-column">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/Fiv1HMRunDM"
              title="Setup Tutorial"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          <div className="ghl-text-column">
            <p className="ghl-text-paragraph">
              Get your SMS marketing up and running effortlessly in 5 minutes with{" "}
              <span className="ghl-highlight">TextLinks + HighLevel</span> and enjoy
              unlimited text messaging capabilities without the hassle of A2P
              registration or per-message charges.
            </p>

            <div className="ghl-content-stats">
              <div className="ghl-stat">
                <ion-icon name="people-outline" className="ghl-icon"></ion-icon>
                <p>120 Active Accounts</p>
              </div>
              <div className="ghl-stat">
                <ion-icon name="chatbubble-outline" className="ghl-icon"></ion-icon>
                <p>120k Messages/Day</p>
              </div>
            </div>
          </div>
        </div>

        {/* SECOND ROW: Text (left) + Video (right) */}
        <div className="ghl-content-row reverse">
          <div className="ghl-text-column">
            <h2 className="ghl-section-title">
              Ditch Twilio, MessageBird &amp; EZText
            </h2>
            <p className="ghl-text-paragraph">
              Cut costs and streamline your text messaging process with{" "}
              <strong>TextLinks</strong>. Say goodbye to expensive third-party
              services. Connect your SIM card directly to HighLevel and start
              sending messages for as low as <strong>$0.00167 per SMS</strong>.
            </p>
            <button
              className="ghl-btn-secondary ghl-btn-large"
              onClick={() => window.open('https://youtu.be/yh9zxE1iCQk', '_blank')}
            >
              View Pricing &amp; Feature Comparison
            </button>
          </div>

          <div className="ghl-video-column">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/yh9zxE1iCQk"
              title="Pricing Comparison"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* CTA SECTION */}
        <div className="ghl-cta-section">
          <h3>Compare Pricing &amp; Features</h3>
          <p className="ghl-text-paragraph">
            Explore our flexible plans that fit your needs and maximize your ROI with{" "}
            <strong>TextLink</strong>.
          </p>
          <button
            className="ghl-btn-primary ghl-btn-large"
            onClick={() => (window.location.href = '/signup')}
          >            Get Started with TextLink
          </button>
        </div>
      </div>
    </>
  );
}

export default GHLSMSIntegration;
